import React from "react"
import { Link } from "gatsby"
import { useState } from "react"

import BtnBurger from "./../../atoms/btn-burger/btn-burger"

import "./sub-layout.scss"
export default function SubLayout(props) {
  const { isMobile, children } = props
  const [isOpenMenu, setIsOpenMenu] = useState(false)

  return (
    <div className="sub-layout">
      <div className="sub-layout-container">
        <div className={`nav-menu ${isMobile ? "mobile" : "desktop"}`}>
          {isMobile && (
            <BtnBurger
              isOpen={isOpenMenu}
              onClick={() => {
                setIsOpenMenu(!isOpenMenu)
              }}
            />
          )}
          <div
            className={`nav-menu-container ${isOpenMenu ? "open" : "close"}`}
          >
            <div className="menu-wrapper">
              <Link to={"/"} activeClassName="active">
                INICIO
              </Link>
              <Link to={"/como-participo"} activeClassName="active">
                ¿CÓMO PARTICIPO?
              </Link>
              <Link to={"/juega"} activeClassName="active">
                JUEGA
              </Link>
              <Link to={"/top"} activeClassName="active">
                TOP
              </Link>
              <Link className="tyc" to={"/terminos"} activeClassName="active">
                TÉRMINOS Y CONDICIONES
              </Link>
            </div>
          </div>
        </div>
        <div
          className={`sub-layout-container-body ${
            isOpenMenu ? "open" : "close"
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
